import React, { createContext, useContext, useReducer } from 'react';
const StateContext = createContext();
export const { Provider } = StateContext;


export const StateProvider = ({ reducer, initialState, children }) => (
  <Provider value={useReducer(reducer, initialState)}>
    {children}
  </Provider>
);

export const getState = () => useContext(StateContext);



// WEBPACK FOOTER //
// ./resources/assets/js/components/shop-search/state/index.jsx